import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';
import { normalizeInteger } from '../../../../../utils/normalizeInteger';
import { KgIcon, PieceIcon, VolumeIcon } from '../../../../../components/text-icon';
import { FormCheckboxField } from '../../../../../semantic-ui/components/form-checkbox-field';
import { TariffTypeField } from './components/TariffTypeField';
import { CustomLoader } from '../../../../../components/custom-loader';

export const AutoparkTransportFormView = ({
	isTransportTypesListLoading,
	transportTypesOptionsList,
	autoparkTransportTariffTypesList,
	isAutoparkTransportTariffTypesListLoading,
	addressesListOptions,
	isAddressesListLoading,
}) => {
	if (isAutoparkTransportTariffTypesListLoading) {
		return <CustomLoader />;
	}

	return (
		<Grid className="autopark-transport-form">
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Название транспорта
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите название транспорта"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Доступен
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<div className="autopark-transport-form__checkbox">
						<Field name="is_allow" component={FormCheckboxField} toggle type="checkbox" />
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Тип транспорта
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<Field
						name="type_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={transportTypesOptionsList}
						search
						loading={isTransportTypesListLoading}
						disabled={isTransportTypesListLoading}
						noResultsMessage="Типы транспорта не найдены"
						placeholder="Выберите тип транспорта"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Грузоподъемность
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<Field
						name="weight"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						icon={KgIcon}
						placeholder="Укажите грузоподъемность"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Вместимость
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<Field
						name="volume"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						icon={VolumeIcon}
						placeholder="Укажите вместимость"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Кол-во доступного авто
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<Field
						name="count"
						type="text"
						normalize={normalizeInteger}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите кол-во доступного авто"
						icon={PieceIcon}
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Стартовая локация
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<Field
						name="address_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={addressesListOptions}
						search
						loading={isAddressesListLoading}
						disabled={isAddressesListLoading}
						noResultsMessage="Адреса не найдены"
						placeholder="Выберите стартовую локацию"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-transport-form__row">
				<Grid.Column width={6} className="autopark-transport-form__column">
					Запретить учет возврата на склад
				</Grid.Column>
				<Grid.Column width={7} className="autopark-transport-form__column">
					<div className="autopark-transport-form__checkbox">
						<Field name="is_deny_refund" component={FormCheckboxField} toggle type="checkbox" />
					</div>
				</Grid.Column>
			</Grid.Row>

			<TariffTypeField
				tariffTypes={autoparkTransportTariffTypesList}
				isLoading={isAutoparkTransportTariffTypesListLoading}
			/>
		</Grid>
	);
};

AutoparkTransportFormView.propTypes = {
	isTransportTypesListLoading: PropTypes.bool.isRequired,
	transportTypesOptionsList: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	autoparkTransportTariffTypesList: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAutoparkTransportTariffTypesListLoading: PropTypes.bool.isRequired,
	addressesListOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAddressesListLoading: PropTypes.bool.isRequired,
};
